import { connect } from 'react-redux';
import { IGetVillageListResponseSchema } from '../../../node/repositories/countryside-search/entities/entities/GetVillageListResponseSchema';
import { IApplicationState, TTypedThunkDispatch } from '../../types/store';

import { CommutePopup } from '.';
import { COMMUTE_POPUP_TAB_LABELS, CommutePopupTabs } from '../../interfaces/filters';
import { TIndexableObject } from '../../interfaces/villages';
import { CommuteButtonStatus } from '../../store/commute_popup';
import { changeCommutePopupTab, onCommutePopupAccept, showCommutePopup } from '../../store/commute_popup/actions';
import { getCommuteButtonStatus } from '../../utils/roads';
import { pick } from '../../utils/pick';

export interface ICommutePopupProps {
  opened: boolean;
  activeTab: CommutePopupTabs;
  roadsButtonStatus: CommuteButtonStatus;
  stationsButtonStatus: CommuteButtonStatus;
  tabLabels: TIndexableObject;
  roadData?: IGetVillageListResponseSchema['roadData'];
  stationData?: IGetVillageListResponseSchema['stationData'];
}

export interface ICommutePopupDispatchProps {
  changeTab(value: CommutePopupTabs): void;
  closePopup(): void;
  onPopupAccept(): void;
}

export type TCommutePopupProps = ICommutePopupProps & ICommutePopupDispatchProps;

export function mapStateToProps(state: IApplicationState): ICommutePopupProps {
  const {
    commutePopup: { opened, activeTab },
    roads: { regionHasRoads, roadDistance, selectedRoads },
    stations: { regionHasStations, stationDistance, selectedStations },
    villageList: { roadData, stationData },
  } = state;
  const allowedTabKeys = [
    regionHasRoads ? CommutePopupTabs.Roads : '',
    regionHasStations ? CommutePopupTabs.Stations : '',
  ].filter(Boolean);

  return {
    activeTab,
    opened,
    roadData,
    roadsButtonStatus: getCommuteButtonStatus(roadData as Record<number, number>, roadDistance, selectedRoads),
    stationData,
    stationsButtonStatus: getCommuteButtonStatus(
      stationData as Record<number, number>,
      stationDistance,
      selectedStations,
    ),
    tabLabels: pick(COMMUTE_POPUP_TAB_LABELS, allowedTabKeys) as TIndexableObject,
  };
}

export function mapDispatchToProps(dispatch: TTypedThunkDispatch): ICommutePopupDispatchProps {
  return {
    changeTab: (value: CommutePopupTabs) => dispatch(changeCommutePopupTab(value)),
    closePopup: () => dispatch(showCommutePopup(false)),
    onPopupAccept: () => dispatch(onCommutePopupAccept()),
  };
}

export const CommutePopupContainer = connect<ICommutePopupProps, ICommutePopupDispatchProps>(
  mapStateToProps,
  mapDispatchToProps,
)(CommutePopup);
